import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4745f358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新建账号")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置密码")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_9 = { class: "createOrUpdateMember" }
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

interface MemberVo {
  id: string;
  code: string;
  name: string;
  mobile: string;
  job: string;
  companyRoleId: string;
  status: number;
}

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);

const createOrEditFormData: MemberVo = {
  id: "",
  code: "",
  mobile:"",
  name: "",
  job: "",
  companyRoleId: "",
  status: 0,
};
const bindData = reactive({
  memberStatusOptions: [
    {
      value: "",
      label: "全部状态",
    },
    {
      value: "0",
      label: "待激活",
    },
    {
      value: "1",
      label: "正常",
    },
    {
      value: "2",
      label: "过期",
    },
    {
      value: "3",
      label: "锁定",
    },
  ],
  memberRoleList: [],
  memberPageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      status: "",
      keyword: "",
    },
  },
  memberPageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
  createOrEditFormData: createOrEditFormData,
  createOrEditFormTitle: "",
});

const handleSizeChangeEvent = (value: any) => {
  bindData.memberPageParams.pageSize = value;
  bindData.memberPageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.memberPageParams.curPage = value;
  searchEvent();
};

const searchEvent = () => {
  store
    .dispatch("accountListModule/pageMemberList", bindData.memberPageParams)
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          switch (obj.status) {
            case 0:
              obj.statusName = "待激活";
              break;
            case 1:
              obj.statusName = "正常";
              break;
            case 2:
              obj.statusName = "过期";
              break;
            case 3:
              obj.statusName = "锁定";
              break;
            default:
              obj.statusName = "--";
              break;
          }
        }
        bindData.memberPageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();

//新增或更新
const createOrEditDialogVisible = ref(false);

const createOrEditHandleCloseEvent = (done: () => void) => {
  done();
};

const loadSelect = () => {
  store.dispatch("accountListModule/listMemberRole", {}).then(
    (data) => {
      //成功
      bindData.memberRoleList = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const showCreateFormEvent = () => {
  loadSelect();
  createOrEditDialogVisible.value = true;
  bindData.createOrEditFormData = {
    id: "",
    code: "",
    mobile:"",
    name: "",
    job: "",
    companyRoleId: "",
    status: 0,
  };
  bindData.createOrEditFormTitle = "新建账号";
};

const showUpdateFormEvent = (index: number, row: MemberVo) => {
  loadSelect();
  createOrEditDialogVisible.value = true;
  bindData.createOrEditFormData = row;
  bindData.createOrEditFormTitle = "编辑账号";
};

const changeMemberCodeEvent = () => {
  const params = {
    memberCode: bindData.createOrEditFormData.code,
  };
  store.dispatch("accountListModule/checkMemberCodeUse", params).then(
    (data) => {
      //成功
      ElMessage.success("当前会员账号可以使用.");
    },
    (error) => {
      ElMessage.error(error.msg);
    }
  );
};

const deleteEvent = (index: number, row: MemberVo) => {
  ElMessageBox.confirm(`您确定要删除 ${row.name} [${row.code}] 吗?`)
    .then(() => {
      const params = {
        memberId: row.id,
      };
      store.dispatch("accountListModule/deleteMember", params).then(
        (data) => {
          //成功
          ElMessage.success("删除成功.");
          searchEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};


const restPasswordEvent = (index: number, row: MemberVo) => {
  ElMessageBox.confirm(`您确定要重置 ${row.name} [${row.code}] 密码吗?`)
    .then(() => {
      const params = {
        id: row.id,
      };
      store.dispatch("accountListModule/updatePassword", params).then(
        (data) => {
          //成功
           ElMessageBox.alert(
                `重置成功. 请复制密码: ${data.result}`,
                "系统消息",
                {
                  confirmButtonText: "关闭",
                  callback: (action: Action) => {},
                }
              );

        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};

const lockEvent = (row: MemberVo,status:number) => {
  var msg =`您确定要解锁 ${row.name} [${row.code}] 吗?`;
  if(status == 3){
     msg =`您确定要锁定 ${row.name} [${row.code}] 吗?`;
  }
  ElMessageBox.confirm(msg)
    .then(() => {
      const params = {
        id: row.id,
        status:status
      };
      store.dispatch("accountListModule/updateLockStatus", params).then(
        (data) => {
          //成功
           var msg =`解锁成功!`;
          if(status == 3){
            msg =`锁定成功!`;
          }
          ElMessage.success(msg);
          searchEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};

const memberFormRef = ref<FormInstance>();

const validateName = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入名称"));
  } else {
    callback();
  }
};

const memberRules = reactive({
  name: [{ required: true, validator: validateName, trigger: "blur" }],
});

const submitMemberForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      store
        .dispatch(
          "accountListModule/saveOrUpdateMember",
          bindData.createOrEditFormData
        )
        .then(
          (data) => {
            //成功
            createOrEditDialogVisible.value = false;
            if (
              data.result &&
              data.result.password &&
              data.result.password.length > 0
            ) {
              ElMessageBox.alert(
                `保存成功. 请复制和密码，账号：${data.result.code} 初始密码: ${data.result.password}`,
                "系统消息",
                {
                  confirmButtonText: "关闭",
                  callback: (action: Action) => {},
                }
              );
            } else {
              ElMessage.success("保存成功");
            }

            searchEvent();
          },
          (error) => {
            ElMessageBox.alert(error.msg, "系统消息", {
              confirmButtonText: "关闭",
              callback: (action: Action) => {},
            });
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "account-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "account-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).memberPageParams.filtrate.status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).memberPageParams.filtrate.status) = $event)),
                  placeholder: "全部状态",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).memberStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "account-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "",
                  size: "large",
                  modelValue: _unref(bindData).memberPageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).memberPageParams.filtrate.keyword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "account-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          class: "account-search-rt",
          type: "primary",
          size: "large",
          onClick: showCreateFormEvent
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(bindData).memberPageResult.result,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "code",
          label: "账号",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "job",
          label: "职务",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "roleName",
          label: "角色",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "statusName",
          label: "状态",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (showUpdateFormEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (restPasswordEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (scope.row.isSuperadmin != 'Y')
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 0,
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (deleteEvent(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            ((scope.row.status == 1 || scope.row.status == 0) && scope.row.isSuperadmin != 'Y')
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 1,
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (lockEvent(scope.row,3))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (scope.row.status == 3 && scope.row.isSuperadmin != 'Y')
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 2,
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (lockEvent(scope.row,1))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_container, { class: "account-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).memberPageParams.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).memberPageParams.curPage) = $event)),
          "page-size": _unref(bindData).memberPageParams.pageSize,
          "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).memberPageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).memberPageResult.totalCount,
          "onUpdate:total": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).memberPageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: createOrEditDialogVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createOrEditDialogVisible).value = $event)),
      title: _unref(bindData).createOrEditFormTitle,
      "onUpdate:title": _cache[12] || (_cache[12] = ($event: any) => ((_unref(bindData).createOrEditFormTitle) = $event)),
      width: "40%",
      "before-close": createOrEditHandleCloseEvent
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (submitMemberForm(memberFormRef.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (createOrEditDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_form, {
            ref_key: "memberFormRef",
            ref: memberFormRef,
            model: _unref(bindData).createOrEditFormData,
            "status-icon": "",
            rules: _unref(memberRules),
            "label-width": "120px",
            class: "memberForm"
          }, {
            default: _withCtx(() => [
              (_unref(bindData).createOrEditFormData.code)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "帐号",
                    prop: "code"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(bindData).createOrEditFormData.code), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: "名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.name) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "手机号",
                prop: "mobile"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.mobile,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.mobile) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "职务",
                prop: "job"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.job,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.job) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "角色",
                prop: "companyRoleId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(bindData).createOrEditFormData.companyRoleId,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).createOrEditFormData.companyRoleId) = $event)),
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).memberRoleList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})